module.exports = __webpack_public_path__ + "media/images/sp/top/kodawari_resort@2x-c13dce59771954b7bf9c24fb76a867af.webp";